import React from 'react';
import {Box, Typography} from '@mui/material';
import LoadingComponent from '@Components/LoadingComponent/LoadingComponent';
import ChatBubbleStyles from './ChatBubbleStyles';
import themeCreator from '@Themes/themeCreator'; // Import loading spinner component
import MarkdownRenderer from '@Components/Markdown/MarkdownRenderer'; // Import loading spinner component

const ChatBubble = ({text, sender, popupWidth, isFullScreen = false  }) => {
  const theme=themeCreator();
  // Boolean to determine if the sender is the bot
  const isBot = sender === 'bot'|| sender === 'loading';

  return (

    <ChatBubbleStyles
      className="bubble"
      isBot={isBot}
      popupWidth={popupWidth}
      isFullScreen={isFullScreen}
    >
      {sender === 'loading' ? (
        <Box className="loadingMessage">
          <Typography className="loadingText">
            {text}
          </Typography>
        </Box>
      ) : isBot? (
          <Box className="bubbleText">
              <MarkdownRenderer markdownText={text} />
          </Box>
        ):(
          <Typography className="bubbleText">{text}</Typography>
      )
      }
    </ChatBubbleStyles>
  );
};

export default React.memo(ChatBubble);
